// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale de.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'Mein Profil',
    settings: 'Einstellungen',
    theme: 'Design',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    support: 'Support',
    back: 'Zurück',
    forward: 'Vorwärts',
    collapseSidebar: 'Seitenleiste einklappen',
    expandSidebar: 'Seitenleiste ausklappen',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Angemeldet',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Nur als {roles}. Rolle wechseln: unten links über dein Konto → Rolle.',
    body: 'Diesen Bereich hast du als {roles}. Gerade arbeitest du als {active}.',
    action: 'Als {role} öffnen',
    where: 'Deine Rolle kannst du jederzeit unten links über dein Konto → Rolle wechseln.',
    listOr: '{list} oder {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Kalender öffnen',
      previousMonth: 'Voriger Monat',
      nextMonth: 'Nächster Monat',
      month: 'Monat',
      year: 'Jahr',
      clear: 'Datum löschen',
      dayToken: 'TT',
      monthToken: 'MM',
      yearToken: 'JJJJ',
    },
    deactivate: 'Deaktivieren',
    revoke: 'Entziehen',
    remove: 'Entfernen',
    actions: 'Aktionen',
    calendar: 'Kalender',
    cancel: 'Abbrechen',
    close: 'Schließen',
    confirmTitle: 'Bestätigen',
    contactSupport: 'Support kontaktieren',
    copyLink: 'Link kopieren',
    edit: 'Bearbeiten',
    language: 'Sprache',
    linkCopied: 'Link kopiert',
    linkCopyFailed: 'Link konnte nicht kopiert werden',
    moduleListHeading: 'Deine Module',
    moduleTeaserAction: 'In der Abrechnung hinzufügen',
    moduleTeaserHeading: 'Ebenfalls Teil von lumi',
    moduleTeaserNote: 'Der Workspace-Inhaber, die Admins und die Billing Manager können diese Module hinzufügen.',
    moduleTeaserTag: 'Nicht in deinem Tarif',
    no: 'Nein',
    nothingHere: 'Noch nichts vorhanden',
    ok: 'OK',
    refresh: 'Aktualisieren',
    retry: 'Erneut versuchen',
    role: 'Rolle',
    save: 'Speichern',
    search: 'Suchen',
    switchModule: 'Modul wechseln',
    tabsNext: 'Weitere Tabs anzeigen',
    tabsPrevious: 'Vorherige Tabs anzeigen',
    understood: 'Verstanden',
    userDeactivated: '{name} (deaktiviert)',
    yes: 'Ja',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Anmeldung fehlgeschlagen. Bitte überprüfe deine E-Mail-Adresse und dein Passwort.',
      MASTER_INVITE_REJECTED: 'Diese Einladung wurde abgelehnt, weil die Angaben zur Person nicht akzeptiert wurden. Prüfe E-Mail-Adresse und Name im Personendatensatz und versuche es erneut.',
      PERSON_EMAIL_INVALID: 'Für diese Person ist keine gültige E-Mail-Adresse hinterlegt, daher kann kein Login eingeladen werden. Korrigiere zuerst die Adresse im Personendatensatz.',
      PERSON_PHONE_INVALID: 'Diese Mobilnummer ist nicht gültig. Gib sie im internationalen Format ein, mit + und Ländervorwahl, z. B. +49 151 23456789.',
      PERSON_ACCESS_PHONE_TAKEN: 'Eine andere Person hat schon einen Login mit dieser Mobilnummer oder bekommt gerade einen. Eine Nummer, eine Person.',
      PHONE_ACCESS_UNAVAILABLE: 'Zugang per Mobilnummer ist hier nicht verfügbar – für diesen Workspace oder für das Land dieser Nummer. Nimm stattdessen eine E-Mail-Adresse.',
      SUITE_ROLE_NEEDS_EMAIL: 'Diese Person meldet sich mit einer Mobilnummer an und hat keine E-Mail-Adresse. Suite-Rollen bekommen Rechts-, Rechnungs- und Einwilligungsmails und brauchen deshalb eine Adresse.',
      OWNER_NEEDS_EMAIL: 'Diese Person meldet sich mit einer Mobilnummer an und hat keine E-Mail-Adresse. Die Inhaberschaft bekommt Rechts- und Vertragsmails und braucht deshalb eine Adresse.',
      RECORD_CHANGED: 'Jemand anderes hat diesen Datensatz geändert, während du ihn bearbeitet hast. Lade ihn neu – deine Eingaben bleiben als Entwurf erhalten.',
    },
    appUpdatedBody: 'Diese Seite konnte nicht vollständig geladen werden, weil die App aktualisiert wurde. Bitte lade neu, um fortzufahren.',
    appUpdatedTitle: 'Eine neue Version ist verfügbar',
    conflict: 'Diese Aktion steht im Konflikt mit dem aktuellen Stand. Bitte lade neu und versuche es erneut.',
    contactSupport: 'Support kontaktieren',
    exhausted: 'Das scheint wirklich defekt zu sein. Das tut uns leid. Bitte wende dich an den Support.',
    failedTitle: 'Aktion fehlgeschlagen',
    forbidden: 'Dir fehlt die Berechtigung für diese Aktion.',
    loadFailedTitle: 'Konnte nicht geladen werden',
    network: 'Keine Verbindung zum Server. Bitte prüfe deine Internetverbindung.',
    notFound: 'Der angeforderte Eintrag wurde nicht gefunden.',
    rateLimited: 'Zu viele Anfragen. Bitte warte einen Moment und versuche es erneut.',
    recordChangedReload: 'Jemand anderes hat diesen Datensatz gespeichert, nachdem du ihn geöffnet hast, deshalb wurde deine Änderung nicht übernommen. Lade neu, um den aktuellen Stand zu sehen – deine Eingaben bleiben erhalten und lassen sich wiederherstellen.',
    refreshFailedTitle: 'Das ist möglicherweise nicht mehr aktuell',
    server: 'Auf dem Server ist ein Fehler aufgetreten. Bitte versuche es später erneut.',
    timeout: 'Der Server hat nicht rechtzeitig geantwortet. Bitte versuche es gleich noch einmal.',
    unauthorized: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
    unexpected: 'Beim Anzeigen ist etwas schiefgelaufen. Bitte versuche es erneut.',
    validation: 'Bitte überprüfe deine Eingaben.',
  },
  notReady: {
    title: 'Das ist noch nicht für dich bereit',
    body: 'Dein Arbeitsbereich wird noch vorbereitet. Wir bringen dich in 5 Sekunden zurück zum Workspace.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Dieser Workspace ist nicht erreichbar',
    body: 'Diesen Workspace gibt es nicht oder er ist gerade nicht erreichbar — bitte prüfe die Adresse, die du aufgerufen hast.',
    accountLead: 'Deine eigenen Daten und deine Rechnungen erreichst du weiterhin über dein lumi-Konto.',
    accountCta: 'Zum lumi-Konto',
    supportLead: 'Wenn das ein Versehen ist, melde dich — dann klären wir das gemeinsam.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'Du hast keinen Zugang zu diesem Workspace',
      body: 'Du bist angemeldet, aber nicht (oder nicht mehr) Mitglied dieses Workspaces. Warst du Gast in einer Demo, ist die Demo beendet oder deine Einladung wurde zurückgezogen.',
      accountLead: 'Dein eigenes lumi-Konto ist davon nicht betroffen.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Workspace gesperrt',
      suspendedMessage: 'Dieser Workspace ist gesperrt. Bitte wende dich an uns, um den Zugang wiederherzustellen.',
      lockedBody: 'Dieser Workspace wurde wegen eines offenen Abrechnungsproblems gesperrt. Der Zugriff auf alle Module ist derzeit ausgesetzt.',
      lockedSupportLead: 'Wende dich an unser Support-Team, um den Zugang wiederherzustellen:',
      lockedSupportCta: 'Support kontaktieren',
      lockoutOn: 'Andernfalls wird er am {date} gesperrt.',
      fixCardTitle: 'Karte aktualisieren',
      fixCardBody: 'Deine letzte Zahlung wurde abgelehnt, weil deine Karte nicht akzeptiert wurde.',
      fixCardCta: 'Karte aktualisieren',
      softDeclineTitle: 'Zahlung sicherstellen',
      softDeclineBody: 'Wir konnten deine letzte Zahlung nicht einziehen und versuchen es automatisch erneut. Stelle sicher, dass dein Zahlungsmittel gedeckt ist.',
      softDeclineCta: 'Zahlungsmittel prüfen',
      scaTitle: 'Zahlung bestätigen',
      scaBody: 'Deine Bank muss diese Zahlung bestätigen, bevor wir sie einziehen können.',
      scaCta: 'Zahlung bestätigen',
      recoveryError: 'Die Zahlung konnte gerade nicht gestartet werden. Bitte versuche es gleich noch einmal.',
      chargebackTitle: 'Zurückgebuchte Zahlung begleichen',
      chargebackBody: 'Deine Bank hat eine Zahlung zurückgebucht, sie ist damit wieder offen. Füge eine Zahlungsmethode hinzu, um sie zu begleichen.',
      chargebackCta: 'Zahlungsmethode hinzufügen',
      trialTitle: 'Zahlungsmethode hinzufügen',
      trialBody: 'Deine Testphase ist abgelaufen. Füge eine Zahlungsmethode hinzu, damit dieser Workspace aktiv bleibt.',
      trialCta: 'Zahlungsmethode hinzufügen',
      reviewTitle: 'Abrechnung prüfen',
      reviewBody: 'Für diesen Workspace ist eine Abrechnungsaktion erforderlich, damit er aktiv bleibt.',
      reviewCta: 'Abrechnung verwalten',
      contactTitle: 'Administration kontaktieren',
      contactBody: 'Ein Abrechnungsproblem muss bearbeitet werden, damit dieser Workspace aktiv bleibt.',
    },
  },
  legalNoticeBanner: {
    title: 'Rechtliche Hinweise brauchen deine Aufmerksamkeit',
    employeeBody: 'Einladungen sind pausiert, bis der Datenschutzhinweis für Mitarbeitende vollständig ist.',
    candidateBody: 'Das Karriereportal ist offline, bis die Hinweise für Bewerbende vollständig sind.',
    imprintBody: 'Das Karriereportal ist offline, bis ein Impressum gespeichert ist.',
    candidateImprintBody: 'Das Karriereportal ist offline, bis die Hinweise für Bewerbende vollständig sind und ein Impressum gespeichert ist.',
    cta: 'Rechtliche Hinweise öffnen',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Braucht dich noch:',
    hide: 'Ausblenden',
    timeRules: {
      link: 'Arbeitszeitregeln',
      cta: 'Prüfen',
      body: 'Die Arbeitszeitregeln sind noch nicht geprüft. lumi rechnet mit den gesetzlichen Standardregeln und weist nur hin, bis jemand bestätigt, dass sie für euch passen.',
    },
    legal: { link: 'Rechtliche Hinweise ausfüllen' },
    billing: {
      link: 'Abrechnung vervollständigen',
      cta: 'Abrechnung öffnen',
      bodyBoth: 'Hinterlege Rechnungsdaten und eine Zahlungsmethode, damit dein Arbeitsbereich ohne Unterbrechung weiterläuft.',
      bodyInvoiceDetails: 'Hinterlege deine Rechnungsdaten, damit deine Rechnungen korrekt ausgestellt werden.',
      bodyPaymentMethod: 'Hinterlege eine Zahlungsmethode, damit dein Arbeitsbereich ohne Unterbrechung weiterläuft.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Support-Zugriff',
    until: 'Befristeter Support-Zugriff bis {until} — alles, was Sie hier tun, steht im Audit-Log dieses Tenants.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: 'Bist Du noch da?',
    idleBody: 'Du warst eine Weile inaktiv. Zu Deiner Sicherheit melden wir Dich automatisch ab.',
    idleStay: 'Angemeldet bleiben',
    idleSignedOut: 'Du wurdest nach {minutes} Minuten Inaktivität abgemeldet. Bitte melde Dich erneut an.',
  },
  // Formular-Entwürfe im Browser (owner-stamped, 7 Tage, nur typisierte Werte —
  // app-kit utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Nicht gespeicherter Entwurf',
    bannerSavedAt: 'Auf diesem Gerät gespeichert: {when}',
    bannerRecordChanged: 'Der Datensatz wurde seit diesem Entwurf geändert. Wiederherstellen setzt nur die Felder zurück, die du geändert hast.',
    restore: 'Wiederherstellen',
    discard: 'Verwerfen',
    closeTitle: 'Eingaben in „{form}“ verwerfen?',
    closeBody: 'Nicht gespeicherte Eingaben gehen verloren.',
    closeConfirm: 'Verwerfen',
    closeCancel: 'Weiter bearbeiten',
    recordChangedTitle: 'Von jemand anderem geändert',
    reload: 'Neu laden',
    forms: {
      'apprentice': {
        planStation: 'Ausbildungsplan-Station',
        skillCatalogue: 'Kompetenzkatalog',
        trainingData: 'Ausbildungsdaten',
      },
      'ats': {
        workflowEditor: 'Workflow-Editor',
      },
      'backoffice': {
        applicationForm: 'Bewerbung',
        createApplication: 'Neue Bewerbung',
        customField: 'Benutzerdefiniertes Feld',
        customFields: 'Benutzerdefinierte Felder',
        emailSettings: 'E-Mail-Einstellungen',
        jobAd: 'Stellenanzeige',
        jobAdTemplate: 'Stellenanzeigen-Vorlage',
        jobEdit: 'Stelle',
        portalSettings: 'Karriereportal-Einstellungen',
        ravenBatchPublish: 'Sammel-Stellenveröffentlichung',
        ravenPublish: 'Stellenveröffentlichung',
        role: 'Rolle',
        suggestion: 'Vorschlag',
        supportTicket: 'Support-Ticket',
        supportTicketReply: 'Support-Ticket-Antwort',
        talentEdit: 'Talentprofil',
        workflowAction: 'Workflow-Aktion',
        workflowCondition: 'Workflow-Bedingung',
        workflowGuard: 'Workflow-Bedingungsprüfung',
        workflowState: 'Workflow-Status',
        workflowTransition: 'Workflow-Übergang',
      },
      'people': {
        bankAccount: 'Bankverbindung',
        companyProfile: 'Unternehmensprofil',
        employmentContract: 'Arbeitsvertrag',
        myProfile: 'Mein Profil',
        onboardingTemplate: 'Onboarding-Vorlage',
        oneTimePayment: 'Einmalzahlung',
        orgUnit: 'Organisationseinheit',
        person: 'Person',
        taxProfile: 'Steuerprofil',
        wageAssignment: 'Lohnpfändung',
      },
      'system-admin': {
        fileQuota: 'Dateikontingent',
        skillDetail: 'Kompetenzdetail',
        suggestionNotes: 'Vorschlagsnotizen',
      },
      'time': {
        blueprint: 'Arbeitszeitmodell',
        leaveRequest: 'Abwesenheitsantrag',
        leaveType: 'Abwesenheitsart',
        orgGroup: 'Organisationsgruppe',
        project: 'Projekt',
        role: 'Rolle',
        userProfile: 'Benutzerprofil',
        weekGrid: 'Wochenraster',
        workTimeModel: 'Arbeitszeitmodell',
      },
      'user': {
        ssoSettings: 'SSO-Einstellungen',
      },
      'workspace': {
        billingProfile: 'Abrechnungsprofil',
        wizardGeneral: 'Einrichtungsassistent',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    terms: 'AGB',
    label: 'Rechtliche Hinweise',
    employeeNotice: 'Datenschutz bei {company}',
  },
  dataImport: {
    title: 'Daten-Import',
    intro: 'Bestandsdaten aus einem Altsystem importieren: Datei hochladen, Feld-Zuordnung prüfen, Probelauf ansehen und erst dann übernehmen.',
    backToList: 'Zur Übersicht',
    sourceSystem: 'Quellsystem',
    cancelled: 'Dieser Import wurde abgebrochen.',
    steps: {
      upload: 'Hochladen',
      analysis: 'Analyse',
      mapping: 'Zuordnung',
      dryRun: 'Probelauf',
      commit: 'Übernahme',
    },
    status: {
      uploaded: 'Hochgeladen',
      analyzing: 'Wird analysiert',
      mapping_ready: 'Zuordnung prüfen',
      dry_running: 'Probelauf läuft',
      dry_run_ready: 'Probelauf fertig',
      committing: 'Wird übernommen',
      completed: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
      cancelled: 'Abgebrochen',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'SQL-Dump',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Direkt',
      date: 'Datum',
      number: 'Zahl',
      boolean: 'Ja/Nein',
      enum_map: 'Werte-Zuordnung',
      split_name: 'Name teilen',
      concat: 'Zusammenfügen',
      const: 'Konstante',
      skip: 'Ignorieren',
    },
    upload: {
      sourceSystem: 'Name des Quellsystems',
      sourceSystemHint: 'Wird als Referenz gespeichert, damit ein erneuter Import dieselben Datensätze aktualisiert statt sie zu duplizieren.',
      sourceSystemPlaceholder: 'z. B. altes_hr_system',
      sourceSystemFirst: 'Bitte zuerst das Quellsystem benennen.',
      dropHint: 'Datei hierher ziehen oder auswählen',
      formats: 'CSV, Excel (XLSX), JSON oder SQL-Dump — max. 50 MB',
      browse: 'Datei auswählen',
      uploading: 'Wird hochgeladen …',
    },
    running: {
      uploaded: 'Analyse wird gestartet …',
      analyzing: 'Datei wird analysiert …',
      dry_running: 'Probelauf läuft …',
      committing: 'Daten werden übernommen …',
      hint: 'Das kann bei großen Dateien einige Minuten dauern. Die Seite aktualisiert sich automatisch.',
    },
    failed: {
      title: 'Import fehlgeschlagen',
    },
    mapping: {
      hint: 'Prüfe die vorgeschlagene Zuordnung: Für jede Tabelle das Ziel und je Spalte das Feld. Hervorgehobene Zeilen sind unsichere Vorschläge.',
      targetEntity: 'Ziel',
      skipTable: 'Nicht importieren',
      skippedTable: 'Diese Tabelle wird nicht importiert.',
      ignoreColumn: 'Ignorieren',
      sourceColumn: 'Spalte',
      sample: 'Beispielwerte',
      targetField: 'Zielfeld',
      transform: 'Umwandlung',
      preview: 'Vorschau',
      rowCount: '{count} Zeilen',
      patternHint: 'Datumsmuster, z. B. DD.MM.YYYY',
      multiTargetHint: 'Ziel {index} von {total} — dieselbe Datei füllt mehrere Ziele',
      valueMap: 'Werte zuordnen',
      valueMapHint: 'Ordne die Quellwerte den im System erlaubten Werten zu. Nicht zugeordnete Werte erzeugen im Probelauf einen Fehler je Zeile. Grundlage sind bis zu 20 unterschiedliche Beispielwerte der Spalte.',
      valueMapUnmapped: '— nicht zugeordnet —',
      addColumnRow: 'Spalte erneut zuordnen',
      customFieldBadge: 'Eigenes Feld',
      createCustomField: 'Neues eigenes Feld anlegen…',
      confirm: 'Zuordnung übernehmen & Probelauf starten',
    },
    report: {
      dryRunHint: 'Probelauf — es wurde noch nichts gespeichert. Prüfe die Zahlen und Fehler, bevor du die Übernahme startest.',
      completedHint: 'Import abgeschlossen. Die Daten sind übernommen.',
      created: 'Neu',
      updated: 'Aktualisiert',
      skipped: 'Übersprungen',
      errors: 'Fehler',
      errorList: '{count} Fehler',
      downloadErrors: 'Alle Fehler herunterladen',
      row: 'Zeile',
      errorMessage: 'Meldung',
      backToMapping: 'Zurück zur Zuordnung',
      commit: 'Daten übernehmen',
      commitConfirmTitle: 'Daten übernehmen?',
      commitConfirmBody: 'Der Import schreibt die Daten jetzt in dieses Modul. Neue Datensätze werden angelegt, bestehende aktualisiert. Das lässt sich nicht automatisch rückgängig machen.',
      commitStarted: 'Übernahme gestartet – die Daten werden jetzt geschrieben.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: '{field} ist leer, braucht aber in jeder Zeile einen Wert.',
      unknownField: '{field} lässt sich hier nicht importieren.',
      invalidEnum: '„{value}“ ist kein erlaubter Wert für {field}. Erlaubt sind: {allowed}. Ordne den Wert in der Zuordnung unter „Werte zuordnen“ zu.',
      unresolved: {
        person: 'Keine Person gefunden, deren {keys} „{value}“ ist.',
        supervisor: 'Keine Führungskraft gefunden, deren {keys} „{value}“ ist.',
        functionalSupervisor: 'Keine fachliche Führungskraft gefunden, deren {keys} „{value}“ ist.',
        orgUnit: 'Keine Org-Einheit gefunden, deren {keys} „{value}“ ist.',
        parentOrgUnit: 'Keine übergeordnete Org-Einheit gefunden, deren {keys} „{value}“ ist.',
      },
      supervisorRequired: 'Keine Führungskraft gefunden, deren {keys} „{value}“ ist – und die Person hat noch keine. Jede aktive Person braucht eine: Importiere die Führungskraft zuerst oder nenne eine, die es schon gibt.',
      unknownEntity: 'Diese Art von Daten lässt sich hier nicht importieren.',
      emailLinked: 'Diese Person meldet sich mit dieser E-Mail-Adresse bei lumi an, deshalb kann der Import sie nicht ändern. Trag in der Datei ihre bisherige Adresse ein oder importiere die Spalte E-Mail nicht.',
      supervisorMissing: 'Jede aktive Person braucht eine Führungskraft, und diese Person hat keine. Nenne eine in der Datei oder lege die Führungskraft zuerst an.',
      transformFailed: '„{value}“ in der Spalte {field} ließ sich nicht umwandeln. Prüfe das Format unter „Umwandlung“ in der Zuordnung.',
      transformFailedNoValue: 'Ein Wert in der Spalte {field} ließ sich nicht umwandeln. Prüfe das Format unter „Umwandlung“ in der Zuordnung.',
      unknown: 'Diese Zeile wurde nicht übernommen. Die Einzelheiten stehen in der Fehlerdatei.',
      ambiguous: {
        collision: '{ref}: „{value}“ passt auf zwei verschiedene Einträge – als externe ID auf einen, als {other} auf einen anderen. Der Import rät nicht: Mach den Verweis in der Datei eindeutig.',
        otherSystem: '{ref}: „{value}“ ist keine externe ID aus diesem Quellsystem, aber eine aus „{system}“ – und passt zugleich als {other} auf einen Eintrag. Der Import rät nicht: Importiere mit dem Quellsystem „{system}“, wenn derselbe gemeint ist, oder mach den Verweis eindeutig.',
        holderHasExternalId: '{ref}: „{value}“ passt nur als {other} – und dieser Eintrag hat in diesem Quellsystem schon die externe ID „{otherId}“. Der Import rät nicht: Verweise mit „{otherId}“, wenn er gemeint ist.',
      },
      refs: {
        person: 'Person',
        supervisor: 'Führungskraft',
        functionalSupervisor: 'Fachliche Führungskraft',
        orgUnit: 'Org-Einheit',
        parentOrgUnit: 'Übergeordnete Org-Einheit',
      },
      supervisorInactive: {
        supervisor: 'Die genannte Führungskraft ist nicht mehr aktiv und kann deshalb niemanden führen.',
        functional: 'Die genannte fachliche Führungskraft ist nicht mehr aktiv und kann deshalb niemanden führen.',
      },
      supervisorUnconfirmed: {
        supervisor: 'Die genannte Führungskraft ist noch nicht von HR bestätigt und kann deshalb niemanden führen. Bestätige sie zuerst in People.',
        functional: 'Die genannte fachliche Führungskraft ist noch nicht von HR bestätigt und kann deshalb niemanden führen. Bestätige sie zuerst in People.',
      },
      datesInverted: 'Das Datum unter {end} liegt vor dem unter {start}.',
      agreementCodeInvalid: '{field} erlaubt nur Buchstaben, Ziffern, „-“, „_“ und „.“, höchstens 60 Zeichen und ohne Leerzeichen.',
      statusTransition: 'Ein Vertrag kann nicht von „{from}“ zu „{to}“ wechseln.',
      reportingCycle: 'Diese Zuordnung würde die Berichtslinie im Kreis schließen.',
      ambiguousOrgCode: 'Mehrere Org-Einheiten verschiedener Art haben den Schlüssel „{value}“. Verweise mit der externen ID auf die richtige.',
      keys: {
        externalId: 'externe ID',
        employeeNumber: 'Personalnummer',
        code: 'Schlüssel',
      },
    },
    list: {
      title: 'Bisherige Importe',
      file: 'Datei',
      system: 'Quellsystem',
      status: 'Status',
      created: 'Erstellt',
      empty: 'Noch keine Importe.',
      open: 'Öffnen',
      delete: 'Löschen',
      deleteConfirmTitle: 'Import löschen?',
      deleteConfirmBody: '„{file}“ und alle zugehörigen Import-Dateien werden entfernt. Bereits übernommene Daten bleiben erhalten.',
      deleted: 'Import „{file}“ gelöscht.',
    },
  },
  dataExport: {
    title: 'HR-Open-Export',
    intro: 'Exportiert die Daten dieses Moduls als HR Open 4.5 (HR-JSON) — validiert gegen den Standard.',
    create: 'Export erstellen',
    creating: 'Wird erstellt …',
    download: 'Herunterladen',
    password: {
      title: 'ZIP-Passwort — nur jetzt sichtbar',
      hint: 'Der Export wird als passwortgeschütztes ZIP (AES-256) erstellt, da er personenbezogene Daten enthält. Kopiere das Passwort jetzt — es wird nicht erneut angezeigt. Zum Öffnen z. B. 7-Zip, WinZip oder Keka verwenden.',
      copy: 'Passwort kopieren',
      copied: 'Kopiert',
    },
    empty: 'Noch keine Exporte.',
    columns: {
      standard: 'Standard',
      status: 'Status',
      items: 'Datensätze',
      created: 'Erstellt',
    },
    status: {
      queued: 'In Warteschlange',
      generating: 'Wird erzeugt',
      completed: 'Fertig',
      failed: 'Fehlgeschlagen',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Übersetzungen',
    translationsHint: 'Der Name in anderen Sprachen. Leere Felder zeigen den Namen oben.',
    systemHint: 'Systemrolle: lumi benennt sie in jeder Sprache. Name und Beschreibung lassen sich nicht ändern, die Berechtigungen schon.',
  },
  demoModules: {
    legend: 'Module in der Demo',
    booked: 'Gebucht – immer dabei',
  },
  demoStage: {
    label: 'Demo',
    viewingAs: 'Ansicht als',
    personaPlaceholder: 'Rolle wählen',
    persona: {
      team_lead: 'Teamleitung',
      employee: 'Mitarbeiter',
      hr_admin: 'HR-Admin',
      recruiter: 'Recruiter',
      ats_admin: 'ATS-Admin',
      council_member: 'Betriebsratsmitglied',
      apprentice: 'Auszubildende:r',
      trainer: 'Ausbilder:in',
    },
    // What each role's journey actually does (picker rows) — one line, keyed
    // by persona key, derived from demo-cast.v5.md's journey list.
    personaDoes: {
      team_lead: 'Entscheidet über Abwesenheits- und Korrekturanträge und bewertet Bewerbungen.',
      employee: 'Bucht Arbeitstage, beantragt Abwesenheiten und lässt Einträge korrigieren.',
      hr_admin: 'Legt Personen, Projekte und Stellen an.',
      recruiter: 'Bringt Bewerbungen durch die Erstprüfung und plant Interviews.',
      ats_admin: 'Entscheidet über Abwesenheiten, bewertet Bewerbungen und legt Stellen an.',
      council_member: 'Gibt das Votum des Betriebsrats zu Stellen und Angeboten ab.',
      apprentice: 'Hakt Stationen im Ausbildungsplan ab und bucht Arbeitstage.',
      trainer: 'Prüft Berichte der Azubis und setzt ihre Prüfungen an.',
    },
    picker: {
      title: 'Aus wessen Sicht schaust du in die Demo?',
      subtitle: '{count} Kolleg:innen bei {company}. Jede Rolle hat eigene Aufgaben – deine Häkchen bleiben pro Rolle erhalten.',
      taskCount: '{total} Aufgabe | {total} Aufgaben',
    },
    intro: {
      lead: 'ist erfunden. Die Menschen darin sind ebenfalls erfunden. Alles unter der Kopfleiste gehört zur Demo – du nimmst darin verschiedene Rollen ein. Dein echter Account bleibt davon unberührt.',
      bridgeBefore: 'Du kannst die Demo jederzeit beenden. Alle Daten unten werden dann gelöscht und du kannst ',
      bridgeAfter: ' für deine Organisation einrichten.',
      close: 'Schließen',
    },
    reset: 'Demo zurücksetzen',
    guestMarker: 'Gast',
    guestWelcome: {
      invitedBy: 'Ein:e Kolleg:in von {workspace} hat dich in diese Demo eingeladen.',
      invitedAnon: 'Ein:e Kolleg:in hat dich in diese Demo eingeladen.',
      body: '{company} ist erfunden und wird mit allen anderen in dieser Demo geteilt. Andere haben vielleicht schon etwas ausprobiert, deshalb kann sie angespielt aussehen. „{reset}“ gibt allen einen frischen Start. Dein Zugang endet, wenn die Demo endet. Die Menschen darin sind ebenfalls erfunden.',
    },
    cancel: 'Abbrechen',
    rebuildFailed: 'Die Demo konnte nicht neu aufgebaut werden. Bitte versuch es noch einmal.',
    resetConfirm: {
      title: 'Demo zurücksetzen?',
      body: 'Alles, was {company} gerade enthält, wird verworfen – auch alles, was du oder deine Kolleg:innen eingegeben habt, und der Fortschritt aller auf ihren Reisen – und die Demo wird von Grund auf neu aufgebaut. Alle in der Demo starten frisch; an den Zugängen ändert sich nichts.',
      cta: 'Demo zurücksetzen',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Kolleg:in einladen',
      title: 'Kolleg:in einladen',
      subtitle: 'Kolleg:innen, die du einlädst, sehen diese Demo so, wie sie ist, und können sie selbst ausprobieren.',
      close: 'Schließen',
      loading: 'Wird geladen…',
      retry: 'Erneut versuchen',
      emailLabel: 'Geschäftliche E-Mail-Adresse',
      emailPlaceholder: "name{'@'}firma.de",
      send: 'Einladung senden',
      sendAgain: 'Erneut senden',
      slotsLeft: '{count} Platz frei | {count} Plätze frei',
      exhausted: 'Alle {limit} Plätze sind vergeben. Widerrufe unten eine Einladung, um jemand anderen einzuladen.',
      invalid: 'Gib eine gültige E-Mail-Adresse ein.',
      listTitle: 'In dieser Demo außer dir',
      used: '{used} von {limit} belegt',
      empty: 'Noch niemand eingeladen.',
      state: {
        invited: 'Eingeladen',
        joined: 'Beigetreten',
      },
      revoke: 'Widerrufen',
      revoking: 'Wird widerrufen…',
      revokeFor: 'Zugang für {email} widerrufen',
      about: {
        title: 'Was ein Gast ist',
        sees: 'Ein Gast sieht diese Demo genau so, wie sie gerade ist – auch alles, was du schon ausprobiert hast. „{reset}“ in der Leiste gibt allen einen frischen Start.',
        resets: 'Ein Gast kann die Demo ebenfalls zurücksetzen – für alle in der Demo.',
        limits: 'Ein Gast kann die Demo nie beenden und nie an deinem echten Workspace etwas ändern.',
        ends: 'Gäste werden entfernt, sobald die Demo endet.',
      },
      feedback: {
        sent: 'Einladung an {email} gesendet.',
        resent: 'Einladung an {email} erneut gesendet.',
        undelivered: 'Die E-Mail an {email} konnte nicht zugestellt werden. {email} steht auf der Liste und belegt einen Platz – sende die Einladung erneut, um es nochmal zu versuchen.',
        revoked: 'Der Zugang für {email} wurde widerrufen. Der Platz ist wieder frei.',
        alreadyMember: '{email} hat bereits Zugang zu diesem Workspace.',
        limit: 'Alle Plätze sind vergeben. Widerrufe eine Einladung, um jemand anderen einzuladen.',
        rateLimited: 'Heute wurden zu viele Einladungen verschickt. Bitte versuche es später noch einmal.',
        notLive: 'Einladungen sind nur möglich, solange die Demo läuft. Sie wird gerade neu aufgebaut oder die Einrichtung hat begonnen – versuche es noch einmal, sobald die Demo wieder da ist.',
        operator: 'Du bist als Systembetreuung angemeldet. Systembetreuung kann keine Kolleg:innen in die Demo eines Kunden einladen.',
        operatorNotMember: '{email} gehört zu einem lumi-Betreuerkonto, das nicht in die Demo eines Kunden eintreten kann. Bitte lade eine andere Adresse ein.',
        notAPerson: '{email} gehört zu einem Konto, das keine Person ist, etwa einem Dienstkonto. Bitte lade die eigene Arbeits-E-Mail-Adresse einer Kollegin oder eines Kollegen ein.',
        forbidden: 'Nur die Workspace-Inhaberin oder der Workspace-Inhaber und Suite-Admins können Kolleg:innen einladen.',
        noticeIncomplete: 'Einladungen sind pausiert, bis die Hinweise für Mitarbeitende unter „Rechtliche Hinweise“ vollständig ausgefüllt sind.',
        accountClosed: 'Dieses Konto wurde geschlossen und kann nicht eingeladen werden.',
        unavailable: 'Einladungen können gerade nicht gezählt werden. Bitte versuche es gleich noch einmal.',
        revokeFailed: 'Der Zugang für {email} konnte nicht widerrufen werden. Bitte versuche es noch einmal.',
        generic: 'Etwas ist schiefgelaufen. Bitte versuche es noch einmal.',
      },
    },
    leave: 'Demo beenden',
    continueSetup: 'Einrichtung fortsetzen',
    menu: 'Demo-Aktionen',
    signOut: 'Abmelden',
    logoutHint: 'Während der Demo meldest du dich über die Tür in der Demo-Leiste oder über das Menü ab.',
    journey: {
      title: 'Die Reise von {name}',
      count: '{done} von {total} erledigt',
      refresh: 'Reise aktualisieren',
      unknown: 'Einige Prüfungen waren nicht erreichbar – gezeigt wird der letzte bekannte Stand.',
      yay: 'Das war die ganze Reise von {name} – gut gemacht.',
      bridgeAdmin: 'Du hast jede Reise durchlaufen. Wenn du so weit bist, beende die Demo und richte deinen eigenen Arbeitsbereich ein.',
      bridgeUser: 'Du hast jede Reise durchlaufen. Ein Admin kann die Demo beenden und euren Arbeitsbereich einrichten.',
      blockedReset: 'Ein Zurücksetzen bringt es zurück:',
      blocked: {
        gone: 'Was diese Aufgabe braucht, ist nicht mehr da.',
      },
      next: 'Als Nächstes',
      nextCta: 'In {module} öffnen',
      footer: 'Die Demo hakt ab, was du tust.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Benachrichtigungen',
    empty: 'Alles erledigt.',
    markAllRead: 'Alle als gelesen markieren',
    markRead: 'Als gelesen markieren',
    markUnread: 'Als ungelesen markieren',
    loading: 'Wird geladen…',
    openTarget: 'Zum verknüpften Objekt',
    goToAll: 'Zu den Benachrichtigungen',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Stadt oder Gemeinde suchen …',
    keptHint: 'Wird genau so gespeichert, wie du es eingetippt hast – ohne verknüpften Ort.',
    searching: 'Suche läuft …',
    typeMore: 'Mindestens {count} Zeichen eingeben',
    noMatch: 'Kein Treffer – deine Eingabe bleibt erhalten',
    error: 'Suche fehlgeschlagen',
    rateLimited: 'Zu viele Suchanfragen – wird gleich erneut versucht',
    resultsAnnouncement: 'Keine Treffer | 1 Treffer | {count} Treffer',
    clear: 'Ort entfernen',
    noMatchAdd: 'Keine Stadt gefunden – Enter übernimmt den Namen so',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Home',
      description: 'Dein Überblick über den Arbeitsplatz',
    },
    ats: {
      name: 'Recruiting',
      description: 'Stellen, Bewerbungen und der Einstellungsprozess',
    },
    time: {
      name: 'Zeit',
      description: 'Zeiterfassung, Arbeitszeitkonten und Freigaben',
    },
    people: {
      name: 'Personal',
      description: 'Personalakten, Abteilungen und Standorte',
    },
    apprentice: {
      name: 'Azubis',
      description: 'Digitale Berichtshefte und Ausbildungspläne',
    },
  },
};
